import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthLinkType } from '../../../../enums/event/event-data.enum';
import { AuthEventRepo, AuthEventType } from '../../../../enums/event/event.enum';
import { BaseEventData } from '../../../../models/event-data.model';
import { EventTrackingService } from '../../../../services/event-tracking.service';
import { HubBanner } from './banner.model';

@Component({
  selector: 'app-notification-banner-container',
  templateUrl: './notification-banner-container.component.html',
  styleUrls: ['./notification-banner-container.component.scss'],
  standalone: false,
})
export class NotificationBannerContainerComponent {
  @Input() banner: HubBanner;
  @Input() cid: string;
  @Output() updateOptIn = new EventEmitter<boolean>();
  @Output() ignorePaperlessEnrollmentBanner = new EventEmitter<boolean>();

  constructor(private readonly eventTrackingService: EventTrackingService) {}

  firePaperlessEnrollmentEvent() {
    this.eventTrackingService.trackEvent<BaseEventData>(AuthEventType.LINK_CLICK, {
      customerPortalClickLinkText: 'Enroll now',
      customerPortalClickLinkType: AuthLinkType.NAV_TO_PAPERLESS_PROFILE,
      eventRepo: AuthEventRepo.CustomerPortal,
    } as BaseEventData);
  }
}
